import * as s from "../LoginStyled";
import { LOGIN_TAB, LOGIN_STEP } from "../LoginContainer";
import { ReactComponent as EmailIcon } from "assets/icons/unread.svg";
import { ReactComponent as PasskeyIcon } from "assets/icons/passkey.svg";
import { ReactComponent as DwCloudIcon } from "assets/icons/cloud_fill.svg";

interface Props {
  loginTab: LOGIN_TAB;
  onChangeStep: (step: LOGIN_STEP) => void;
  isPasskeyEnabled: boolean;
}
export default function LoginTab({
  loginTab,
  onChangeStep,
  isPasskeyEnabled,
}: Props) {
  return (
    <s.LoginTab>
      <s.LoginTabButton
        isSelected={loginTab === LOGIN_TAB.EMAIL}
        onClick={() => onChangeStep(LOGIN_STEP.INPUT_EMAIL)}
        data-testid="auth-signin-common-login-tab-button-change-step"
      >
        <EmailIcon />
        Email
      </s.LoginTabButton>
      {isPasskeyEnabled && (
        <s.LoginTabButton
          isSelected={loginTab === LOGIN_TAB.PASSKEY}
          onClick={() => onChangeStep(LOGIN_STEP.LOGIN_WITH_PASSKEY)}
          data-testid="auth-signin-common-login-tab-button-change-step-2"
        >
          <PasskeyIcon />
          Passkey
        </s.LoginTabButton>
      )}

      <s.LoginTabButton
        isSelected={loginTab === LOGIN_TAB.DW_CLOUD}
        onClick={() => onChangeStep(LOGIN_STEP.DW_CLOUD)}
        data-testid="auth-signin-common-login-tab-button-change-step-3"
      >
        <DwCloudIcon />
        DW Cloud
      </s.LoginTabButton>
    </s.LoginTab>
  );
}
